export const timerUpload = async () => {
  try {
    
    if(sessionStorage.getItem('setTimer') != 'true' && localStorage.getItem('token') != null) {
        if((localStorage.getItem('timer') != null || localStorage.getItem('timer') != 0)) {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({"minutes": Math.ceil(Number(localStorage.getItem('timer') / 60)), "deviceType": "web"});

            var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
            };

            fetch("http://dev.contestee.net/api/v1/users/increase-login-count", requestOptions)
            .then(response => response.text())
            .then(result => localStorage.setItem('timer', 0))
            .catch(error => console.log('error', error));
        }
    }
    clearInterval(localStorage.getItem('TIMER'));
        
    let TIMER = setInterval(()=> {
        sessionStorage.setItem('setTimer', true);
        let timer = Number(localStorage.getItem('timer'));
        localStorage.setItem('timer', timer + 1);
        localStorage.setItem('TIMER', TIMER);
    }, 1000);
  } catch (err) {
    return null;
  }

}